import { createFileRoute } from '@tanstack/react-router'

import CoverageSheetContent from '@/components/sheets/coverage/coverage-sheet-content'
import { coverageSheetPreload } from '@/components/sheets/coverage/coverage-sheet-preload'

export const Route = createFileRoute('/app/dashboard/$coverageUuid/')({
  component: RouteComponent,
  loader: ({ params, context: { queryClient } }) =>
    coverageSheetPreload(params.coverageUuid, queryClient),
})

function RouteComponent() {
  const { coverageUuid } = Route.useParams()

  return <CoverageSheetContent coverageUuid={coverageUuid} />
}
